module.exports = __webpack_public_path__ + "img/nav_b2_pic3.a2a589f5.png";